import {
  LayoutDashboard, BarChart3, DollarSign, Users, PlusCircle, Settings, Workflow,
  Send, Trophy, CreditCard, Activity, Link, Headset, User,
} from 'lucide-react';

export const navItems = [
  {
    key: "dashboard",
    label: "Dashboard",
    iconComponent: <LayoutDashboard size={16} />,
    path: "/dashboard",
  },
  {
    key: "statistics",
    label: "Estatísticas",
    iconComponent: <BarChart3 size={16} />,
    path: '/statistics',
    requiresBot: true,
  },
  {
    key: "sales",
    label: "Vendas",
    iconComponent: <DollarSign size={16} />,
    path: "/sales",
  },
  {
    key: "leads",
    label: "Leads",
    iconComponent: <Users size={16} />,
    path: "/leads",
  },
  {
    key: "create_bot",
    label: "Criar bot",
    iconComponent: <PlusCircle size={16} />,
    path: "/bots/create",
  },
  {
    key: "manage",
    label: "Editar Bot",
    bottomBarLabel: "Bot",
    iconComponent: <Settings size={16} />,
    path: "/bots/manage",
    requiresBot: true,
  },
  {
    key: "flows",
    label: "Fluxos",
    iconComponent: <Workflow size={16} />,
    path: "/bots/flows",
    is_new: true,
  },
  {
    key: "disparo",
    label: "Disparos",
    iconComponent: <Send size={16} />,
    path: "/disparos",
  },
  {
    key: "ranking",
    label: "Ranking",
    iconComponent: <Trophy size={16} />,
    path: "/ranking",
  },
  {
    key: "pagamentos",
    label: "Pagamentos",
    iconComponent: <CreditCard size={16} />,
    path: "/gateways",
  },
  {
    key: "tracking",
    label: "Trackeamento",
    iconComponent: <Activity size={16} />,
    path: "/tracking",
  },
  {
    key: "redirects",
    label: "Redirecionadores",
    iconComponent: <Link size={16} />,
    path: "/redirecionadores",
  },
  {
    key: "support",
    label: "Suporte",
    iconComponent: <Headset size={16} />,
    path: "/suporte",
  },
  {
    key: "profile",
    label: "Meu Perfil",
    iconComponent: <User size={16} />,
    path: "/profile",
  },
];

// Itens de destaque exibidos na bottom bar mobile (o restante fica atrás de "Mais").
export const bottomBarKeys = ["dashboard", "sales", "manage", "flows"];
